import { useState, useEffect } from 'react';
import { ScrollTrigger } from '../../animations/registerGsap';
import LoadingScreen from './LoadingScreen';
import { useReducedMotion } from '../../hooks/useReducedMotion';

const LOADER_KEY = 'lumora-session-loaded';

const ExperienceProvider = ({ children }) => {
  const [loading, setLoading] = useState(() => {
    if (typeof window === 'undefined') return true;
    return !sessionStorage.getItem(LOADER_KEY);
  });
  const reducedMotion = useReducedMotion();

  const handleLoadComplete = () => {
    sessionStorage.setItem(LOADER_KEY, '1');
    setLoading(false);
    requestAnimationFrame(() => ScrollTrigger.refresh());
  };

  useEffect(() => {
    if (reducedMotion && loading) {
      sessionStorage.setItem(LOADER_KEY, '1');
      setLoading(false);
    }
  }, [reducedMotion, loading]);

  return (
    <>
      {loading && !reducedMotion && (
        <LoadingScreen onComplete={handleLoadComplete} />
      )}
      <div className="relative z-10">{children}</div>
    </>
  );
};

export default ExperienceProvider;
